import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import {
    FormInputComponent,
    InputComponentConfig,
    DataService,
    NotificationService,
} from '@vendure/admin-ui/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
    VariantWithAmount,
    VariantWithAmountArgPayload,
} from './helpers/types';

@Component({
    standalone: true,
    selector: 'variants-amount-form-input',
    imports: [CommonModule, ReactiveFormsModule, FormsModule],
    template: `
        <div class="container" *ngFor="let variant of variants">
            <div>
                <div *ngIf="variant.featuredAsset">
                    <img
                        [src]="variant.featuredAsset.source"
                        alt="Product Variant"
                        width="20"
                    />
                </div>
                <div class="informations">
                    <span>ID: {{ variant.id }}</span>
                    <span>SKU: {{ variant.sku }}</span>
                </div>
            </div>
            <span>Mínimo valor permitido: {{ variant.minAmount }}</span>
            <div *ngIf="variant.maxAmount">
                <span>Máximo valor permitido: {{ variant.maxAmount }}</span>
            </div>
        </div>
    `,
    styles: [
        `
            img {
                width: 20%;
            }

            .informations {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            .container {
                margin-bottom: 30px;
            }

            .custom-button {
                margin-left: 20px;
            }
        `,
    ],
})
export class VariantsAmountFormInput
    implements FormInputComponent<InputComponentConfig>, OnInit
{
    @Input() readonly: boolean = false;
    @Input() formControl!: FormControl;
    @Input() config!: InputComponentConfig;

    variants: VariantWithAmount[] = [];

    constructor(
        private dataService: DataService,
        private notificationService: NotificationService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.searchVariantByIds();
    }

    searchVariantByIds(): void {
        const data: VariantWithAmountArgPayload[] = this.formControl.value;

        const variantIds = data.map((item) => item.variantId.toString());
        this.dataService.product
            .getProductVariants({
                filter: { id: { in: variantIds } },
            })
            .mapStream((response) => response.productVariants.items)
            .subscribe({
                next: (variants) => {
                    this.variants = variants.map((variant) => {
                        const quantity = data.find(
                            (v) => v.variantId === variant.id
                        );

                        return {
                            ...variant,
                            minAmount: quantity?.minAmount || 0,
                            ...(quantity?.maxAmount
                                ? { maxAmount: quantity?.maxAmount }
                                : {}),
                        };
                    });

                    this.cd.detectChanges();
                },
                error: (err) => {
                    this.notificationService.error(
                        'Erro ao buscar variantes: ',
                        err
                    );
                },
            });
    }
}
